module.exports = __webpack_public_path__ + "static/img/zaixianzhifu.996af4cc.png";